import { Delete, Edit2 } from '@/components/Icons'
import ImagePreview from '@/components/ImagePreview'

import messages from './messages'

export default ({ intl, onDelete, onEdit }: any) => [
  {
    property: 'displayTitle',
    header: {
      label: intl.formatMessage(messages.displayTitle),
      sortable: true
    }
  },
  {
    property: 'iconUrl',
    header: {
      label: intl.formatMessage(messages.icon)
    },
    cell: {
      formatters: [
        (iconUrl: any) => (
          <ImagePreview id="source-image-preview" className="icon-preview-image" imageUrl={iconUrl} title="" />
        )
      ]
    }
  },
  {
    property: 'id',
    cell: {
      props: {
        style: {
          width: 50
        }
      },
      // TODO Make this a button
      formatters: [(id: any, { rowData }: any) => <Edit2 onClick={() => onEdit(rowData.id)} />]
    }
  },
  {
    property: 'id',

    cell: {
      props: {
        style: {
          width: 50
        }
      },
      // TODO Make this a button
      formatters: [(id: any, { rowData }: any) => <Delete onClick={() => onDelete(rowData)} />]
    }
  }
]
